import React, { useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { book, heavy, regular, bold, colors } from '@/styles';
import { Button, FileInput } from '@/atoms';
import { MockVideoItem } from '@/svgs';

/**
 * EmptyState component
 *
 * @param {import('./EmptyState').EmptyStateProps}
 */
const EmptyState = ({ className, handleUpload, isRebrand }) => {
  const [showIcon, setShowIcon] = useState(true);

  const containerRef = useRef();

  useEffect(() => {
    if (containerRef.current.clientHeight < 400) {
      setShowIcon(false);
    }
  }, []);

  return (
    <div className={`${className} ${isRebrand ? 'brand--new' : ''}`} ref={containerRef}>
      <div className="icon">{showIcon && <MockVideoItem size={35.7} />}</div>
      <div className="title">No videos yet!</div>
      <div className="subtitle">
        Build trust and create lasting connections with simple video replies.
      </div>

      <div className="button">
        <FileInput onFileChange={handleUpload}>
          <Button
            isRebrand={isRebrand}
            rectangle
            label={isRebrand ? 'Record a Video' : 'Upload Videos'}
            color={isRebrand ? colors.electricOrange : colors.kermit}
          />
        </FileInput>
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  /** Emotion base style */
  className: PropTypes.string.isRequired,
  /** what to do on button click */
  handleUpload: PropTypes.func.isRequired,
  /** Use new branding */
  isRebrand: PropTypes.bool,
};

EmptyState.defaultProps = {
  isRebrand: false,
};

const styledEmptyState = styled(EmptyState)`
  align-items: center;
  color: ${colors.boulder};
  display: flex;
  flex-direction: column;
  height: calc(100% - 4.6875rem);
  justify-content: center;
  text-align: center;

  .icon {
    margin: 0 auto 2.57875rem;
  }

  .title {
    ${heavy()}
    color: ${colors.boulder};
    font-size: 1.125rem;
    margin-top: 1rem;
  }

  .subtitle {
    ${book()}
    font-size: 0.875rem;
    line-height: 1.5;
    margin-top: 1rem;
    width: 15.625rem;
  }

  .button {
    margin-top: 2rem;

    button {
      margin: 0 auto;
    }
  }

  &.brand--new {
    .title {
      ${bold()}
    }

    .subtitle {
      ${regular()}
      line-height: 1.25rem;
      margin-top: 1.25rem;
      width: 16rem;
    }

    .button {
      margin-top: 1.5rem;
    }
  }
`;

export default styledEmptyState;
